import { IFreeGames } from '@GFTypes/GameStoreTypes';

export const FREE_GAMES_DEFAULTS: IFreeGames = {
    triggerPositions: [],
    retriggerPositions: [],
    currentSpin: 0,
    totalSpins: 0,
    totalWin: 0,
    spinsWon: 0
};
